<!--
 * @Description: 新增-编辑所有字段类型
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- 2，4 -->
  <!--  {{colItem?.fieldType}} {{colItem?.fieldType === 4}} {{props.propsConditionsItemConditionsItemConditionsItem.operation}} {{propsConditionsItem.operation}}-->
  <template v-if="colItem?.fieldType === 2 || colItem?.business?.fieldType == 2 || colItem?.fieldType === 4 || colItem?.business?.fieldType == 4">
    <jw-select @change="changeLastChild($event, propsConditionsItem?.field)" v-if="propsConditionsItem?.operation === 'equals' || propsConditionsItem?.operation === 'not_equals' || !propsConditionsItem.operation" v-model.trim="propsConditionsItem.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" allow-clear allow-search :max-tag-count="1">
      <jw-option v-for="item in JSON.parse(colItem?.fieldType != 21 ? colItem?.fieldExt : colItem?.business?.fieldExt)" :key="item.value" :title="item.label" :value="item.value" :disabled="!item.isEnabled">{{ item.label }}</jw-option>
    </jw-select>
    <jw-select @change="changeLastChild($event, propsConditionsItem?.field)" v-else-if="propsConditionsItem?.operation === 'in' || propsConditionsItem?.operation === 'not_in'" :placeholder="$t('请选择')" multiple class="rule-form-item-sub-select" v-model.trim="propsConditionsItem.value" :trigger-props="{ updateAtScroll: true }" allow-search :max-tag-count="1">
      <jw-option v-for="item in JSON.parse(colItem?.fieldType != 21 ? colItem?.fieldExt : colItem?.business?.fieldExt)" :key="item.value" :title="item.label" :value="item.value" :disabled="!item.isEnabled">{{ item.label }}</jw-option>
    </jw-select>
    <div style="width: 0" v-else-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
  </template>
  <!--,3，5 -->
  <template v-else-if="colItem?.fieldType === 3 || colItem?.business?.fieldType == 3 || colItem?.fieldType === 5 || colItem?.business?.fieldType == 5">
    <jw-select @change="changeLastChild($event, propsConditionsItem.field)" v-if="propsConditionsItem.operation === 'equals' || propsConditionsItem.operation === 'not_equals' || !propsConditionsItem.operation" v-model.trim="propsConditionsItem.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" allow-clear allow-search :max-tag-count="1">
      <jw-option v-for="item in JSON.parse(colItem?.fieldType != 21 ? colItem?.fieldExt : colItem?.business?.fieldExt)" :key="item.value" :title="item.label" :value="item.value" :disabled="!item.isEnabled">{{ item.label }}</jw-option>
    </jw-select>
    <jw-select @change="changeLastChild($event, propsConditionsItem.field)" v-else-if="propsConditionsItem.operation === 'in' || propsConditionsItem.operation === 'not_in'" :placeholder="$t('请选择')" multiple class="rule-form-item-sub-select" v-model.trim="propsConditionsItem.value" :trigger-props="{ updateAtScroll: true }" allow-search :max-tag-count="1">
      <jw-option v-for="item in JSON.parse(colItem?.fieldType != 21 ? colItem?.fieldExt : colItem?.business?.fieldExt)" :key="item.value" :title="item.label" :value="item.value" :disabled="!item.isEnabled">{{ item.label }}</jw-option>
    </jw-select>
    <div style="width: 0" v-else-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
  </template>
  <!-- 6 人员选择是一个单框与角色权限中的添加人员一样 -->
  <template v-else-if="colItem?.fieldType === 6 || colItem?.business?.fieldType == 6">
    <template v-if="(propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || !propsConditionsItem.operation">
      <!-- <xl-user-depart @cb="getValUser($event)" :tree="userTree" :isScreen="true" style="width: 100%" :sub="propsConditionsItem"></xl-user-depart> -->

      <fh-person :multiple="propsConditionsItem.operation === 'equals' || propsConditionsItem.operation === 'not_equals' ? false : true" :maxTagCount="2" :item="propsConditionsItem" @cb="getValUser($event)" :popupWidth="250"> </fh-person>
    </template>
    <template v-else>
      <div style="width: 0"></div>
    </template>
  </template>
  <!-- 7数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
  <template v-else-if="(colItem?.fieldType === 7 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || (colItem?.business?.fieldType == 7 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null')">
    <div style="width: 0" v-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
    <jw-input-number @change="changeLastChild($event, propsConditionsItem.field)" v-else class="rule-form-item-sub-select" v-model="propsConditionsItem.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, colItem)" :formatter="(event) => isShowThousandFormatter(event, colItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(colItem, precisionNum)" />
  </template>
  <!-- 8：日期格式 -->
  <template v-else-if="colItem?.fieldType === 8 || colItem?.business?.fieldType == 8">
    <!-- 特殊：目前计算字段中（汇总类的数据范围）没有用日期变量，所以将其排除在外 -->
    <xl-date-variable v-if="props.fromPage !== 'formula'" :objList="colItem" :record="propsConditionsItem" @cb="getDateVariable($event)"></xl-date-variable>
    <!-- 【处理数据时记得只处理以下部分的数据】，上边日期变量组件的数据不要处理:(只要从接口拿到的原始值) -->
    <template v-else>
      <jw-date-picker @change="changeLastChild($event, propsConditionsItem.field)" v-model="propsConditionsItem.value" :format="tools.isJSON(colItem?.fieldExt) ? JSON.parse(colItem?.fieldExt)?.dataType : colItem?.fieldExt" v-if="propsConditionsItem.operation != 'between' && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null'" :placeholder="$t('请选择日期范围')" :show-time="isShowTime(propsConditionsItem.field)" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
      <jw-range-picker type="time-range" @change="changeLastChild($event, propsConditionsItem.field)" v-model="propsConditionsItem.value" v-else-if="propsConditionsItem.operation === 'between'" :show-time="isShowTime(propsConditionsItem.field)" :format="tools.isJSON(colItem?.fieldExt) ? JSON.parse(colItem?.fieldExt)?.dataType : colItem?.fieldExt" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
      <div style="width: 0" v-else-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
    </template>
  </template>
  <!-- 9日期范围 -->

  <template v-else-if="colItem?.fieldType === 9 || colItem?.business?.fieldType == 9">
    <template v-if="props.dateRangeType === 'range' && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null'">
      <jw-range-picker @change="changeLastChild($event, propsConditionsItem.field)" v-if="colItem?.fieldExt == '0' || colItem?.business?.fieldExt == '0'" v-model="propsConditionsItem.value" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" />
      <jw-range-picker @change="changeLastChild($event, propsConditionsItem.field)" v-else-if="colItem?.fieldExt == '1' || colItem?.business?.fieldExt == '1'" class="rule-form-item-sub-select" v-model="propsConditionsItem.value" @select="onSelect" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :trigger-props="{ updateAtScroll: true }" />
      <jw-range-picker @change="changeLastChild($event, propsConditionsItem.field)" v-else v-model="propsConditionsItem.value" class="rule-form-item-sub-select" @select="onSelect" :trigger-props="{ updateAtScroll: true }" />
    </template>
    <template v-else>
      <xl-date-variable v-if="props.fromPage !== 'formula'" :objList="colItem" :record="propsConditionsItem" @cb="getDateVariable($event)"></xl-date-variable>
      <!-- 【处理数据时记得只处理以下部分的数据】，上边日期变量组件的数据不要处理:(只要从接口拿到的原始值) -->
      <template v-else>
        <jw-date-picker @change="changeLastChild($event, propsConditionsItem.field)" v-model="propsConditionsItem.value" :format="tools.isJSON(colItem?.fieldExt) ? JSON.parse(colItem?.fieldExt)?.dataType : colItem?.fieldExt" v-if="propsConditionsItem.operation != 'between' && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null'" :placeholder="$t('请选择日期范围')" :show-time="isShowTime(propsConditionsItem.field)" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
        <jw-range-picker type="time-range" @change="changeLastChild($event, propsConditionsItem.field)" v-model="propsConditionsItem.value" v-else-if="propsConditionsItem.operation === 'between'" :show-time="isShowTime(propsConditionsItem.field)" :format="tools.isJSON(colItem?.fieldExt) ? JSON.parse(colItem?.fieldExt)?.dataType : colItem?.fieldExt" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
        <div style="width: 0" v-else-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
      </template>
    </template>
  </template>

  <!-- <template v-else-if="(colItem?.fieldType === 9 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || (colItem?.business?.fieldType == 9 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null')">
    <template v-if="props.dateRangeType === 'range'">
      <jw-range-picker @change="changeLastChild($event, propsConditionsItem.field)" v-if="colItem?.fieldExt == '0' || colItem?.business?.fieldExt == '0'" v-model="propsConditionsItem.value" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" />
      <jw-range-picker @change="changeLastChild($event, propsConditionsItem.field)" v-else-if="colItem?.fieldExt == '1' || colItem?.business?.fieldExt == '1'" class="rule-form-item-sub-select" v-model="propsConditionsItem.value" @select="onSelect" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :trigger-props="{ updateAtScroll: true }" />
      <jw-range-picker @change="changeLastChild($event, propsConditionsItem.field)" v-else v-model="propsConditionsItem.value" class="rule-form-item-sub-select" @select="onSelect" :trigger-props="{ updateAtScroll: true }" />
    </template>
    <template v-else>
      <jw-date-picker style="width: 100%" @change="changeLastChild($event, propsConditionsItem.field)" v-model="propsConditionsItem.value" :placeholder="$t('请选择日期')" class="date-select-item rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
    </template>
  </template> -->
  <!-- 10 级联选择器 :path-mode="true"-->
  <template v-else-if="colItem?.fieldType === 10 || colItem?.business?.fieldType == 10">
    <jw-cascader :path-mode="true" v-if="propsConditionsItem.operation === 'equals' || propsConditionsItem.operation === 'not_equals' || !propsConditionsItem.operation" class="rule-form-item-sub-select" :options="JSON.parse(colItem?.fieldType != 21 ? colItem?.fieldExt : colItem?.business?.fieldExt)" allow-search v-model="propsConditionsItem.value" @change="changeLastChild($event, propsConditionsItem.field)" :placeholder="$t('请选择')" />
    <jw-cascader :path-mode="true" v-else-if="propsConditionsItem.operation === 'in' || propsConditionsItem.operation === 'not_in'" class="rule-form-item-sub-select" :options="JSON.parse(colItem?.fieldType != 21 ? colItem?.fieldExt : colItem?.business?.fieldExt)" allow-search v-model="propsConditionsItem.value" @change="changeLastChild($event, propsConditionsItem.field)" :placeholder="$t('请选择')" multiple />
    <div style="width: 0" v-else-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
  </template>
  <!-- 16 金额 -->
  <template v-else-if="colItem?.fieldType === 16 || colItem?.business?.fieldType == 16">
    <jw-input-number v-if="(propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || !propsConditionsItem.operation" @change="changeLastChild($event, propsConditionsItem.field)" class="rule-form-item-sub-select" v-model="propsConditionsItem.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, colItem)" :formatter="(event) => isShowThousandFormatter(event, colItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(colItem, precisionNum)" />
    <div v-else style="width: 0"></div>
  </template>
  <!-- 22 部门 -->
  <template v-else-if="colItem?.fieldType === 22 || colItem?.business?.fieldType == 22">
    <xl-tree-member-modal :popup="popup" :tree="departTree" v-if="(propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || !propsConditionsItem.operation" @cb="getValUser($event)" :multipleDep="propsConditionsItem.operation === 'equals' || propsConditionsItem.operation === 'not_equals' ? false : true" :depart="propsConditionsItem.departList">
      <jw-input-tag v-model="propsConditionsItem.userDept" :max-tag-count="2" class="rule-form-item-sub-select" readonly :placeholder="$t('请选择')" />
    </xl-tree-member-modal>
    <div style="width: 0" v-else></div>
  </template>
  <!-- 23百分比 -->
  <template v-else-if="(colItem?.fieldType === 23 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || (colItem?.business?.fieldType == 23 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null')">
    <div style="width: 0" v-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
    <jw-input-number @change="changeLastChild($event, propsConditionsItem.field)" v-else class="rule-form-item-sub-select" v-model="propsConditionsItem.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, colItem)" :precision="getPrecision(colItem, precisionNum)">
      <template #append> % </template>
    </jw-input-number>
  </template>
  <!-- 24计算字段 -->
  <template v-else-if="(colItem?.fieldType === 24 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || (colItem?.business?.fieldType == 24 && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null')">
    <!-- 计算字段的fieldExt的type=5 :数字（汇总累计）type=7 :数字-->
    <!-- 456789 -->
    <template v-if="isTypeIn([5, 7])">
      <div style="width: 0" v-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
      <jw-input-number @change="changeLastChild($event, propsConditionsItem.field)" v-else class="rule-form-item-sub-select" v-model="propsConditionsItem.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, colItem)" :formatter="(event) => isShowThousandFormatter(event, colItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(colItem, precisionNum, true)" />
    </template>
    <!-- 计算字段的fieldExt的type=6 :金额(汇总金额) type=16 :金额 -->
    <template v-else-if="isTypeIn([6, 16])">
      <jw-input-number v-if="(propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null') || !propsConditionsItem.operation" @change="changeLastChild($event, propsConditionsItem.field)" class="rule-form-item-sub-select" v-model="propsConditionsItem.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, colItem)" :formatter="(event) => isShowThousandFormatter(event, colItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(colItem, precisionNum, true)" />
      <div v-else style="width: 0"></div>
    </template>
    <!-- 计算字段的fieldExt的type=0 :文本 -->
    <template v-else-if="isTypeIn([0])">
      <jw-input v-model.trim="propsConditionsItem.value" :input-attrs="{ type: 'search' }" :name="'conditionschildren'" :field="`colItem.value`" :placeholder="$t('请输入')" @change="changeLastChild($event, propsConditionsItem.field)" class="rule-form-item-sub-select" />
    </template>
    <!-- 计算字段的fieldExt的type=23 :百分比 -->
    <template v-else-if="isTypeIn([23])">
      <div style="width: 0" v-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
      <jw-input-number @change="changeLastChild($event, propsConditionsItem.field)" v-else class="rule-form-item-sub-select" v-model="propsConditionsItem.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, colItem)" :precision="getPrecision(colItem, precisionNum, true)">
        <template #append> % </template>
      </jw-input-number>
    </template>
    <!-- 计算字段的fieldExt的type=8 :日期 -->
    <template v-else-if="isTypeIn([8])">
      <jw-date-picker @change="changeLastChild($event, propsConditionsItem.field)" v-model="propsConditionsItem.value" :format="colItem?.fieldType != 21 ? JSON.parse(colItem?.fieldExt)?.dataType : JSON.parse(colItem?.business?.fieldExt)?.dataType" v-if="propsConditionsItem.operation != 'between' && propsConditionsItem.operation != 'null' && propsConditionsItem.operation != 'not_null'" :placeholder="$t('请选择日期范围')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
      <jw-range-picker type="time-range" @change="changeLastChild($event, propsConditionsItem.field)" v-model="propsConditionsItem.value" :format="colItem?.fieldType != 21 ? JSON.parse(colItem?.fieldExt)?.dataType : JSON.parse(colItem?.business?.fieldExt)?.dataType" v-else-if="propsConditionsItem.operation === 'between'" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
      <div style="width: 0" v-else-if="propsConditionsItem.operation === 'null' || propsConditionsItem.operation === 'not_null'"></div>
    </template>
  </template>
  <!-- 单行文本 obj[sub.field] -->
  <jw-input v-else v-model.trim="propsConditionsItem.value" :input-attrs="{ type: 'search' }" :placeholder="$t('请输入')" :name="'conditionschildren'" :field="`colItem.value`" @change="changeLastChild($event, propsConditionsItem.field)" class="rule-form-item-sub-select" />
</template>

<script setup>
import { tools } from '@/utils/tools.js';
import dayjs from 'dayjs';
import { ref, reactive, computed } from 'vue'; // computed nextTick
import { useI18n } from 'vue-i18n';
import _ from 'lodash';
import { Message } from '@arco-design/web-vue';
// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();
const { t } = useI18n();
const props = defineProps({
  popup: {
    type: String,
    default: 'body'
  },
  col: {
    // 列头：包含key
    type: Object,
    default: () => {}
  },
  conditionsItem: {
    // 筛选的内容
    type: Object,
    default: () => {}
  },
  from: {
    //2 是明细行 1 是基本信息
    type: Number || String,
    default: () => 1
  },
  dateRangeType: {
    type: String,
    default: () => 'range' // range 日期区间 begin 开始时间 end 结束时间
  }
});
const emits = defineEmits(['cb']);
const colItem = ref(props?.col);
const propsConditionsItem = ref(props?.conditionsItem);
console.log(153, colItem.value, propsConditionsItem.value);
const data = reactive({});
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
// const userTree = ref({
//   checkDepartment: false,
//   isAll: false
// });
// 是否展示时间
const isShowTime = (ext) => {
  return ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm');
};

// 日期类型获取日期变量
const getDateVariable = (record) => {
  propsConditionsItem.value.value = record;
  emits('cb', updateCondition());
};

//最后框
const changeLastChild = (e) => {
  console.log('筛选子级变化', e);
  if (Array.isArray(e)) {
    data.fieldThree = e[0] ?? '';
  } else {
    data.fieldThree = e ?? '';
  }
  emits('cb', updateCondition());
};
// 人员
const getValUser = (v) => {
  const userNames = computed(() => v?.userList?.map((u) => u.userName));
  const departNames = computed(() => v?.departList?.map((u) => u.departmentName));
  const ud = propsConditionsItem.value;
  ud.userDept = [...userNames.value, ...departNames.value];
  ud.userList = v.userList;
  ud.departList = v.departList;
  const userIds = ud.userList?.map((c) => c.id);
  const departIds = ud.departList?.map((c) => c.id);
  ud.value = JSON.stringify({
    userIds,
    departIds
  });
  if (ud.operation === 'equals' || ud.operation === 'not_equals') {
    if (ud.userDept.length > 1) {
      Message.warning(t('请注意，只可选择一个人员或部门哦'));
    }
  }
  emits('cb', updateCondition());
};

// 筛选后的数据处理
const updateCondition = () => {
  const conditionsItem = JSON.parse(JSON.stringify(propsConditionsItem.value));
  if (Array.isArray(conditionsItem.value) && (conditionsItem.operation === 'in' || conditionsItem.operation === 'not_in')) {
    if (Array.isArray(conditionsItem.value[0]) && isCascader(conditionsItem)) {
      conditionsItem.value = conditionsItem.value?.map((subArr) => subArr?.join('/'))?.join(',');
    } else {
      if (Array.isArray(conditionsItem.value)) {
        conditionsItem.value = conditionsItem.value?.filter(Boolean)?.join(',');
      }
    }
  } else if (Array.isArray(conditionsItem.value) && conditionsItem.operation === 'between') {
    //只有日期，日期范围有'between'操作符
    const obj = {
      beginDate: conditionsItem.value[0],
      endDate: conditionsItem.value[1]
    };
    conditionsItem.value = JSON.stringify(obj);
  } else if ((Array.isArray(conditionsItem.value) && conditionsItem.operation === 'equals') || conditionsItem.operation === 'not_equals') {
    if (isCascader(conditionsItem) && Array.isArray(conditionsItem.value)) {
      conditionsItem.value = conditionsItem.value?.join('/');
    }
  }
  if (isPrice(conditionsItem) && conditionsItem.operation !== 'null' && conditionsItem.operation !== 'not_null') {
    // conditionsItem.value = conditionsItem.value * 10000;
  }
  if (isNumber(conditionsItem) && conditionsItem.operation !== 'null' && conditionsItem.operation !== 'not_null') {
    conditionsItem.value = Number(conditionsItem.value);
  }
  // 处理百分比字段类型
  if (isPercentage(conditionsItem) && conditionsItem.operation !== 'null' && conditionsItem.operation !== 'not_null') {
    if (conditionsItem.value && !isNaN(Number(conditionsItem.value))) {
      let fieldExt = '';
      if (conditionsItem.setting.fieldType === 21) {
        if (conditionsItem.setting?.business.fieldType === 24) {
          fieldExt = (tools.isJSON(conditionsItem.setting?.business?.fieldExt) && JSON.parse(conditionsItem.setting?.business?.fieldExt)?.dataType) || 2;
        } else {
          fieldExt = (tools.isJSON(conditionsItem.setting?.business?.fieldExt) && JSON.parse(conditionsItem.setting?.business?.fieldExt)?.numberFormat) || 2;
        }
      } else {
        if (conditionsItem.setting.fieldType === 24) {
          fieldExt = (tools.isJSON(conditionsItem.setting?.fieldExt) && JSON.parse(conditionsItem.setting?.fieldExt)?.dataType) || 2;
        } else {
          fieldExt = (tools.isJSON(conditionsItem.setting?.fieldExt) && JSON.parse(conditionsItem.setting?.fieldExt)?.numberFormat) || 2;
        }
      }
      console.log('getConditions-setPercentage', fieldExt, JSON.parse(JSON.stringify(conditionsItem.value)));
      // conditionsItem.value = tools.setPercentage(conditionsItem.value, fieldExt);
    }
  }
  // 处理人员字段类型
  if (isUserDepartment(conditionsItem)) {
    if ((conditionsItem.operation != 'null' || conditionsItem.operation != 'not_null') && _.isObject(conditionsItem.value)) {
      conditionsItem.value = JSON.stringify({
        userIds: _.map(conditionsItem.value.userIds, 'id'),
        departIds: _.map(conditionsItem.value.departIds, 'id')
      });
    }
    if (props.fromPage === 'echart' && conditionsItem?.userList?.length > 0) {
      //图表
      conditionsItem.business.userIds = conditionsItem?.userList?.map((v) => {
        return {
          ...v,
          name: v.userName,
          avatar: v.avatarOrigin
        };
      });
    }
  }

  return conditionsItem;
};

// 级联
const isCascader = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 10 || child.setting?.business?.fieldType === 10;
};

// // 日期 日期区间
// const isDteTime = (child) => {
//   if (!child?.setting) return false;
//   return  child.setting.fieldType === 8 || child.setting?.business?.fieldType === 8 || child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [8]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [8]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
// };
// // 日期区间
// const isDateRange = (child) => {
//   if (!child?.setting) return false;
//   return child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9;
// };

// 数字
const isNumber = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 7 || child.setting?.business?.fieldType === 7 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 金额
const isPrice = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 16 || child.setting?.business?.fieldType === 16 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 百分比
const isPercentage = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 23 || child.setting?.business?.fieldType === 23 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [23]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [23]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 人员部门
const isUserDepartment = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 6 || child.setting?.business?.fieldType === 6 || child.setting.fieldType === 22 || child.setting?.business?.fieldType === 22;
};

// 获取字段类型
const parsedFieldType = computed(() => {
  return tools.isJSON(colItem.value?.fieldExt) ? JSON.parse(colItem.value?.fieldExt)?.type : colItem.value?.fieldExt?.type;
});
// 计算字段的判断条件
const isTypeIn = (typeArray) => {
  return typeArray.includes(parsedFieldType.value);
};
</script>
<style scoped lang="less">
@import './table-item-fliter.less';
</style>
